import { render } from "./IconHelp.vue?vue&type=template&id=8b453d28"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconHelp.vue"]])

export default __exports__